/**
 * Lens barrel. Importing this module registers the three provider
 * icon lenses (aws/azure/gcp) in `LensRegistry`.
 *
 * Data-lens behaviour (tier/env/team/cost/risk/age/exposure) is
 * provided by `viewRulesStore` presets — the seven
 * `compass-lens-*` presets in `COMPASS_VIEW_PRESETS` — and the
 * `presetAsLens` adapter. That path lives in `useCompassExplorerView`,
 * which picks a `LensDefinition` from either `LensRegistry` (icons)
 * or `presetAsLens(preset)` (data lenses). See the overbuild audit in
 * `plans/compass/explorer-product-readiness-impl-plan.md` §P2.3.
 */

import { LensRegistry, registerLens } from './registry';
import { awsIconLens } from './awsIconLens';
import { azureIconLens } from './azureIconLens';
import { gcpIconLens } from './gcpIconLens';

let registered = false;

export function registerBuiltInLenses(): void {
  if (registered) return;
  registerLens(awsIconLens);
  registerLens(azureIconLens);
  registerLens(gcpIconLens);
  registered = true;
}

registerBuiltInLenses();

export { LensRegistry, registerLens };
